import { socials } from '../data/siteData'
import './SocialIcons.css'

const items = [
  {
    key: 'instagram',
    href: socials.instagram,
    label: 'AS Elite Gatherings on Instagram',
    path: (
      <>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
      </>
    ),
  },
  {
    key: 'facebook',
    href: socials.facebook,
    label: 'AS Elite Gatherings on Facebook',
    path: (
      <path d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H7v3h3v6h3v-6h3l1-3h-4v-2c0-.6.4-1 1-1z" />
    ),
  },
  {
    key: 'youtube',
    href: socials.youtube,
    label: 'AS Elite Gatherings on YouTube',
    path: (
      <>
        <rect x="3" y="6" width="18" height="12" rx="4" />
        <path d="M10.5 9.5l5 2.5-5 2.5z" fill="currentColor" stroke="none" />
      </>
    ),
  },
]

export default function SocialIcons({ variant = 'band' }) {
  return (
    <div className={`social-icons social-icons--${variant}`}>
      {items.map((item) => (
        <a
          key={item.key}
          href={item.href}
          target="_blank"
          rel="noreferrer"
          aria-label={item.label}
          className="social-icon"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
            {item.path}
          </svg>
        </a>
      ))}
    </div>
  )
}
